import { useRef } from "react";
import { useParams } from "react-router";

import { ModalRef } from "@shared/components";
import { usePaginatedTable } from "@shared/hooks";
import { AgreementProduct } from "@modules/agreements/types/agreementProduct";

export function AgreementProductsController() {
  const { id } = useParams();

  const createProductModalRef = useRef<ModalRef>(null);

  const { rows, refetch, ...tableProps } = usePaginatedTable<AgreementProduct>({
    resource: "v1/product_admin",
    enabled: !!id,
    filters: {
      agreement: id,
    },
  });

  return {
    rows,
    tableProps,
    createProductModalRef,
    refetch,
  };
}


